import { useI18n } from '@/i18n';
import type { SoonItem } from '@/lib/comingSoon';

export function SoonCard({ item }: { item: SoonItem }) {
  const { t } = useI18n();
  const title = item.key ? t(item.key) : (item.title ?? '');

  return (
    <div className="live-family-link is-disabled" aria-disabled="true">
      <article className="live-family is-soon">
        <div className="live-family__media">
          <img src={item.art} alt={title} className="live-family__art" />
          <div className="live-family__scrim" aria-hidden="true" />
          <div className="live-family__copy">
            <h3 className="live-family__title display">{title}</h3>
            <span className="live-family__soon">{t('nav.comingSoon')}</span>
          </div>
        </div>
      </article>
    </div>
  );
}
